module.exports = __webpack_public_path__ + "img/Hand_31_05_22.87399587.png";